// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3ePX0","name":"Header_name__2skPO","birthday":"Header_birthday__29I56","skeleton":"Header_skeleton__3Y5Ur"};